(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('{{ form_id }}');
  if (!form) return;

  form.addEventListener('submit', async function(e) {
    e.preventDefault();

    const submitButton = form.querySelector('button[type="submit"]');
    const originalButtonText = submitButton ? submitButton.innerHTML : 'Submit';

    // Disable button + loading state
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.innerHTML = 'Sending...';
    }

    // Clear previous messages
    const errorDiv = form.querySelector('.contact-form__error');
    const successDiv = form.querySelector('.contact-form__success');
    if (errorDiv) errorDiv.remove();
    if (successDiv) successDiv.remove();

    try {
      const formData = new FormData(form);
      
      const response = await fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const html = await response.text();
      
      // Check if submission was successful (Shopify redirects or shows success)
      if (response.ok && html.includes('contact-form__success')) {
        // Show success message instantly
        const successHTML = `
          <div class="contact-form__success" tabindex="-1" autofocus>
            {{- 'icon-checkmark.svg' | inline_asset_content -}}
            {{- 'blocks.contact_form.post_success' | t -}}
          </div>
        `;
        form.insertAdjacentHTML('afterbegin', successHTML);
        
        // Reset form
        form.reset();
      } else {
        // Show error (fallback)
        const errorHTML = `
          <div class="contact-form__error" tabindex="-1" autofocus>
            {{- 'icon-error.svg' | inline_asset_content -}}
            Something went wrong. Please try again.
          </div>
        `;
        form.insertAdjacentHTML('afterbegin', errorHTML);
      }
    } catch (error) {
      console.error(error);
      const errorHTML = `
        <div class="contact-form__error" tabindex="-1" autofocus>
          {{- 'icon-error.svg' | inline_asset_content -}}
          Failed to send message. Please try again.
        </div>
      `;
      form.insertAdjacentHTML('afterbegin', errorHTML);
    } finally {
      // Restore button
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.innerHTML = originalButtonText;
      }
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
